import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Textarea from 'react-textarea-autosize';
import {
  Button,
  Form,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from 'reactstrap';
import { injectIntl } from 'react-intl';

import {
  APIcreateGroup,
  APIupdateGroup,
} from '../../../api/Group';

import ProcessingSpinner from '../../ProcessingSpinner';

import ErrorBoundary from '../../ErrorBoundary';

class GroupEditModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      name: '',
      description: '',
      saving: false,
      errors: {},
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.handleSaveGroup = this.handleSaveGroup.bind(this);
  }

  componentDidMount() {
    const { group } = this.props;

    if (group) {
      this.setState({
        name: group.name,
        description: group.description,
      });
    }
  }

  validateForm() {
    const { intl } = this.props;
    const { name } = this.state;
    const errors = {};

    if (!name) {
      errors.name = intl.formatMessage({ defaultMessage: 'This field is required' });
    }

    this.setState({ errors });

    if (Object.keys(errors).length > 0) {
      return false;
    }

    return true;
  }

  handleChange(e) {
    const {
      name,
      value,
    } = e.target;
    this.setState({ [name]: value });
  }

  handleKeyPress(e) {
    e.persist();
    if (e.key === 'Enter') {
      e.preventDefault();
      this.handleSaveGroup();
    }
  }

  handleSaveGroup() {
    if (!this.validateForm()) {
      return;
    }

    const {
      name,
      description,
    } = this.state;
    const {
      group,
      handleClose,
      notificationCallback,
    } = this.props;

    this.setState({ saving: true });

    if (group) {
      const updatedGroup = Object.assign({}, group);
      updatedGroup.name = name;
      updatedGroup.description = description;

      APIupdateGroup(updatedGroup)
        .then((response) => {
          if (response.data) {
            notificationCallback(response.data);
            handleClose();
          }
        });
    } else {
      APIcreateGroup({ name, description })
        .then((response) => {
          notificationCallback(response.data);
          handleClose();
        });
    }
  }

  render() {
    const {
      name,
      description,
      errors,
      saving,
    } = this.state;
    const {
      intl,
      group,
      handleClose,
    } = this.props;

    return (
      <ErrorBoundary>
        <ModalHeader toggle={handleClose} className="modal-header-center">
          {group ? (
            intl.formatMessage({ defaultMessage: 'Edit Team' })
          ) : (
            intl.formatMessage({ defaultMessage: 'Create new Team' })
          )}
        </ModalHeader>
        <ModalBody>
          <Form
            className="new-group-form"
            onKeyPress={this.handleKeyPress}
          >
            <FormGroup>
              <Label for="inpGroupName">
                {intl.formatMessage({ defaultMessage: 'Name' })}
              </Label>
              <Input
                type="text"
                name="name"
                id="inpGroupName"
                placeholder={intl.formatMessage({ defaultMessage: 'Team name' })}
                autoFocus={true}
                defaultValue={name}
                onChange={this.handleChange}
                invalid={errors.name !== undefined}
              />
              {errors.name !== undefined && (
                <FormFeedback>
                  {intl.formatMessage({ defaultMessage: 'This field is required' })}
                </FormFeedback>
              )}
            </FormGroup>
            <FormGroup>
              <Label for="inpGroupDescription">
                {intl.formatMessage({ defaultMessage: 'Description' })}
              </Label>
              <Textarea
                name="description"
                id="inpGroupDescription"
                className="form-control"
                placeholder={intl.formatMessage({ defaultMessage: 'Team description (optional)' })}
                defaultValue={description}
                onChange={this.handleChange}
              />
            </FormGroup>
          </Form>
        </ModalBody>
        <ModalFooter>
          <div className="buttons-group">
            <Button
              color="secondary"
              disabled={saving}
              onClick={handleClose}
            >
              {intl.formatMessage({ defaultMessage: 'Cancel' })}
            </Button>
            <Button
              color="primary"
              disabled={saving}
              onClick={this.handleSaveGroup}
            >
              <ProcessingSpinner show={saving} />
              {intl.formatMessage({ defaultMessage: 'Save' })}
            </Button>
          </div>
        </ModalFooter>
      </ErrorBoundary>
    );
  }
}

GroupEditModal.propTypes = {
  intl: PropTypes.object.isRequired,
  handleClose: PropTypes.func.isRequired,
  group: PropTypes.object,
  notificationCallback: PropTypes.func,
};

GroupEditModal.defaultProps = {
  group: null,
  notificationCallback: () => {},
};

export default injectIntl(GroupEditModal);
